import React, { JSX, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Carousel from "react-bootstrap/Carousel";
import { State } from "../../../redux/slices";
import { v4 as uuidv4 } from "uuid";
import { ThunkDispatch } from "redux-thunk";
import { setOpenCloseModalPhotos } from "../../../redux/slices/data/dataSampleView";

const SetActions = () => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  return {
    setOpenCloseModalPhotos: (visible: boolean) => {
      dispatch(setOpenCloseModalPhotos(visible));
    },
  };
};

const CancelButton = () => {
  const { setOpenCloseModalPhotos } = SetActions();
  return (
    <button
      className="cancel-button"
      onClick={() => setOpenCloseModalPhotos(false)}
    >
      X
    </button>
  );
};

const CarouselContainer: React.FC<{
  photos: { signedRequest: string }[];
  initialIndex: number;
}> = ({ photos, initialIndex }) => {
  const [activeIndex, setActiveIndex] = useState(initialIndex);

  useEffect(() => {
    setActiveIndex(initialIndex);
  }, [initialIndex]);

  return (
    <Carousel activeIndex={activeIndex} onSelect={(idx) => setActiveIndex(idx)}>
      {photos.map((photo) => (
        <Carousel.Item
          key={`${photo.signedRequest}${uuidv4()}`}
          interval={1000000}
        >
          <div className="container-carousel">
            <img
              src={photo.signedRequest}
              style={{
                width: "100%",
                maxHeight: "80vh",
                objectFit: "contain",
              }}
              alt="..."
            />
          </div>
        </Carousel.Item>
      ))}
    </Carousel>
  );
};

export const BodyCarouselPhotos = (): JSX.Element => {
  const dispatch = useDispatch<ThunkDispatch<any, any, any>>();
  const { photos, selectedPhotoIndex } = useSelector(
    (state: State) => state.DataSampleViewReducer,
  );

  const closeModal = () => dispatch(setOpenCloseModalPhotos(false));

  return (
    <div className="carousel-component-container" onClick={closeModal}>
      {CancelButton()}
      <div onClick={(e) => e.stopPropagation()}>
        <CarouselContainer photos={photos} initialIndex={selectedPhotoIndex} />
      </div>
    </div>
  );
};
